import { RouteConfig } from 'vue-router';

export default Array<RouteConfig>(
  {
    name: 'Munis',
    path: '/',
    component: () => import('../../views/Munis/Munis.vue'),
    meta: {
      layout: 'main',
      className: 'header-exchange-rates'
    },
    children: [
      {
        name: 'Munis',
        path: '/',
        component: () => import('@/feature/Munis/views/MunisNewPayment.vue'),
      },
      {
        name: 'MunisTemplates',
        path: 'templates',
        component: () => import('@/feature/Munis/views/MunisTemplates.vue'),
      },
      {
        name: "MunisSettlement",
        path: "/munis/:code",
        component: () => import('@/feature/Munis/views/MunisSettlement.vue'),
      },
    ]
  },
);
